module.exports = __webpack_public_path__ + "img/silvery-home.883c9ac.png";